import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65d622e98acb/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/sections/DeviceShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/sections/EnhancedTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de65d622e98acb/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndustriesCarousel"] */ "/tmp/8de65d622e98acb/components/sections/IndustriesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/sections/SolutionsDeepDive.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65d622e98acb/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/app/[locale]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
